import styled from 'styled-components';
export var Panel = styled.div.withConfig({
  displayName: "style__Panel",
  componentId: "sc-19wmago-0"
})(["width:100%;background:white;z-index:300;padding:30px 0;transform:translateZ(0);transition:all 0.5s;"]);
export var Space = styled.div.withConfig({
  displayName: "style__Space",
  componentId: "sc-19wmago-1"
})(["width:15px;"]);
export var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-19wmago-2"
})(["display:inline-block;position:fixed;top:0;width:100%;height:60px;background-color:", ";margin-bottom:20px;padding-top:5px;z-index:1000;"], function (props) {
  return props.background ? props.background : 'transparent';
});
export var Left = styled.span.withConfig({
  displayName: "style__Left",
  componentId: "sc-19wmago-3"
})(["position:relative;line-height:28px;font-size:28px;font-weight:bold;color:", ";left:0;width:70px;top:15px;margin-left:40px;"], function (props) {
  return props.color ? props.color : 'white';
});
export var Right = styled.span.withConfig({
  displayName: "style__Right",
  componentId: "sc-19wmago-4"
})(["position:relative;display:flex;line-height:28px;font-weight:bold;color:", ";margin-top:10px;margin-right:40px;width:50%;right:0;flex-direction:row-reverse;float:right;"], function (props) {
  return props.color ? props.color : 'white';
});
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "sc-19wmago-5"
})(["position:relative;border-radius:10%;height:", ";width:", ";margin-left:15px;"], function (props) {
  return props.height ? props.height : '35px';
}, function (props) {
  return props.width ? props.width : '85px';
});
export var Button = styled.button.withConfig({
  displayName: "style__Button",
  componentId: "sc-19wmago-6"
})(["height:", ";width:", ";border-radius:10%;padding-left:5px;border-color:", ";background:", ";&:focus{outline:0;}", ":hover &{border:none;background:rgba(0,0,0,0.15);}color:", ";display:inline-block;text-align:center;"], function (props) {
  return props.height ? props.height : '40px';
}, function (props) {
  return props.width ? props.width : '70px';
}, function (props) {
  return props.active ? 'rgba(0, 0, 0, 0.015)' : '#33333326';
}, function (props) {
  return props.active ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.015)';
}, ButtonContainer, function (props) {
  return props.color ? props.color : '#33333326';
});